import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Repairs from "@/pages/Repairs";
import TradeIn from "@/pages/TradeIn";
import Branches from "@/pages/Branches";
import PosSystem from "@/pages/PosSystem";
import Contact from "@/pages/Contact";
import AppDownload from "@/pages/AppDownload";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="p-12 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/repairs" element={<Repairs />} />
              <Route path="/trade-in" element={<TradeIn />} />
              <Route path="/branches" element={<Branches />} />
              <Route path="/pos-system" element={<PosSystem />} />
              <Route path="/app" element={<AppDownload />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
